import { Record } from 'immutable';

// ================================================================================================
// Rename MemorizedRules STore
// ================================================================================================

export const mkMemorizedRule = Record({
  id: undefined,
  clientId: undefined,
  isDeleted: undefined,
  payee: undefined,
  transactionType: undefined,
  memo: undefined,
  amount: undefined,
  isNotAutoCategorized: undefined,
  isNotEditableByTransactions: undefined,
  isExcludedFromCalendar: undefined,
  coa: undefined,
  tags: undefined,
  split: undefined,
  applyToExistingTxns: undefined,
});
